<template>
  <section v-if="lista.length">
    <div class="produto-cdlsaude-cadastrofinal">
      <div class="content">
        <div class="row mb-3">
          <div class="col-md-6">
            <Titulo
              title="Preencha seus dados"
              description="Complete todos os dados do titular e dependentes para prosseguir."
            />
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-4"
            :class="{ 'd-none d-md-block': registroSel !== null }"
          >
            <div v-for="(registro, index) in lista" :key="index">
              <button
                class="btn btn-block btn-light justify-content-start mb-2 rounded"
                type="button"
                @click="selecionaCadastro(index)"
                :class="{ active: registroSel === index }"
                v-if="registro.info.name.value"
              >
                <div class="text-left">
                  <div class="label text-muted">
                    {{ registro.info.name.label }}
                  </div>
                  <div class="value">
                    {{ registro.info.name.value }}
                  </div>
                  <div
                    v-if="!registro.concluido"
                    class="text-danger text-small d-flex align-items-center"
                  >
                    <span class="material-icons mr-1 text-small">
                      warning_amber
                    </span>
                    Cadastro incompleto
                  </div>
                  <div v-else class="text-success text-small font-weight-bold">
                    <span class="material-icons mr-1 text-small"> done </span>
                    Cadastro completo
                  </div>
                </div>
              </button>
            </div>
          </div>

          <div class="d-none d-md-flex col-md-8" v-if="registroSel === null">
            <div class="alert alert-info d-flex align-items-center">
              <span class="material-icons"> arrow_back_ios </span> Clique nos
              botões ao lado para preencher o restante dos dados.
            </div>
          </div>
          <div class="col-md-8" v-show="registroSel !== null">
            <div class="card card-body">
              <div class="mb-1 border-bottom pb-3 row">
                <div class="col-md-5">
                  <div class="label text-muted">{{ tipo }}</div>
                  <div class="value">{{ nome }}</div>
                </div>
                <div class="col text-right">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    v-if="tipo === 'dependente'"
                    @click="preencherEndereco()"
                  >
                    <span class="material-icons mr-2">
                      supervisor_account
                    </span>
                    Preencher endereço do Titular
                  </button>
                </div>
              </div>
              <FormulateForm
                name="Cadastro"
                v-model="values"
                @submit="salvarRegistro"
              >
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="select"
                      name="tipoDependente"
                      :options="listaTipoDependentes"
                      label="Tipo Dependente"
                      validation="required"
                      @change="verificaTipoDependente"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="date"
                      name="datacasamento"
                      label="Data de Casamento"
                      validation="required"
                      v-if="values.tipoDependente == '05'"
                      :max="dataMax"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="select"
                      name="estadoCivil"
                      :options="listaEstadoCivil"
                      label="Estado Civil"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="select"
                      name="sexo"
                      :options="tipoSexo"
                      label="Sexo"
                      validation="required"
                    />
                  </div>
                </div>

                <FormulateInput
                  type="text"
                  name="cpf"
                  label="CPF"
                  validation="required"
                  v-mask="'###.###.###-##'"
                  @change="validarCpf()"
                />
                <FormulateInput
                  type="text"
                  name="nomeMae"
                  label="Nome da Mãe"
                  validation="required"
                />
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="email"
                      name="email"
                      label="Email"
                      validation="required|email"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="telefone"
                      label="Telefone"
                      validation="required"
                      v-mask="'(##) #####-####'"
                    />
                  </div>
                </div>

                <Endereco ref="enderecoRef" />
                <FormulateInput type="submit" value="Salvar" />
              </FormulateForm>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            link="/produto/cdl-saude-plano/cadastro"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Próximo"
            @click="validaLista"
            nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
            >PRÓXIMO</Botao
          >
        </div>
      </div>
      <div class="py-5"></div>
    </div>
  </section>
  <section v-else>
    <loading />
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Endereco from "@/components/cadastro/FormEndereco";
import { clearStr, validateCPF } from "../../../helpers";
export default {
  name: "ListaVidas",
  components: { Titulo, Botao, Endereco },
  data() {
    return {
      produto: {
        nome: "CDL Saúde",
        id: "SPC Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Inclusão de Vidas",
          id: "inclusao_vidas",
        },
      ],
      nome: "",
      tipo: "",
      cpfTitular: "",
      values: {},
      lista: [],
      listaEstadoCivil: [],
      tipoSexo: [],
      listaTipoDependentes: [],
      registros: [],
      registroSel: null,
      proximaEtapa: true,
      invalidCpf: null,
      dataMax: null,
    };
  },
  methods: {
    async montaDados() {
      await this.$http
        .get("/api/GestaoSaude/ListarEstadoCivil")
        .then((response) => {
          response.data.forEach((value) => {
            if (value.valor) {
              this.listaEstadoCivil.push({
                value: value.valor,
                label: value.descricao,
              });
            }
          });
        })
        .catch((error) => {
          console.log(error.status);
        });

      await this.$http
        .get("/api/GestaoSaude/ListarTipoSexo")
        .then((response) => {
          response.data.forEach((value) => {
            if (value.valor) {
              this.tipoSexo.push({
                value: value.valor,
                label: value.descricao,
              });
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });

      await this.$http
        .get("/api/CdlBh/ListarTiposDependentes")
        .then((response) => {
          response.data.forEach((value) => {
            if (value.codtipodepend) {
              this.listaTipoDependentes.push({
                value: value.codtipodepend,
                label: value.tipO_DEPENDENCIA,
              });
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });

      this.registros = JSON.parse(localStorage.getItem("cdlsaude_cadastro"));

      for (const field of this.registros) {
        if (field.tipoCadastro === "titular") {
          if (typeof field.cadastroFinal !== "undefined") {
            this.cpfTitular = field.cadastroFinal.cpf;
          }
        }

        this.lista.push({
          info: {
            name: {
              label: field.tipoCadastro,
              value: field.nome,
            },
          },
          concluido: field.concluido ? true : false,
        });
      }

      const date = new Date();
      date.setDate(date.getDate() - 1);

      this.dataMax =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      //this.selecionaCadastro(0);
    },
    preencherEndereco() {
      const dadosTitular = this.registros.filter(
        (dados) => dados.tipoCadastro === "titular"
      );

      this.values.cep = dadosTitular[0].cadastroFinal.cep;
      this.values.rua = dadosTitular[0].cadastroFinal.rua;
      this.values.bairro = dadosTitular[0].cadastroFinal.bairro;
      this.values.cidade = dadosTitular[0].cadastroFinal.cidade;
      this.values.estado = dadosTitular[0].cadastroFinal.estado;
      this.values.complemento = dadosTitular[0].cadastroFinal.complemento;
      this.values.numero = dadosTitular[0].cadastroFinal.numero;
    },
    selecionaCadastro(id) {
      this.$formulate.reset("Cadastro");
      this.registroSel = id;
      this.nome = this.lista[id].info.name.value;
      this.tipo = this.lista[id].info.name.label;

      if (this.registros[id].cadastroFinal) {
        this.values = this.registros[id].cadastroFinal;
      } else {
        this.values = { cep: "" };
        // Se for titular, ja marca o campo como titular
        if (this.registros[id].tipoCadastro === "titular") {
          this.values.tipoDependente = "09";

          const autoPreencher = sessionStorage.getItem(
            "autopreencher_inclusao_vida"
          );
          if (autoPreencher) {
            const dados = this.$user.dadosContatoPrincipal[0];
            this.values.cpf = dados.cpf;
            this.values.cep = dados.cep;
            this.values.nomeMae = dados.mae;
            this.values.email = dados.email;
            this.values.telefone = dados.telefone;
            this.values.numero = dados.numero;
            this.values.complemento = dados.complemento;

            if (dados.cep) {
              this.$refs.enderecoRef.getAddress(dados.cep);
            }
          }
        }
      }
    },
    salvarRegistro() {
      if (!this.invalidCpf) {
        if (this.registros[this.registroSel].tipoCadastro === "titular") {
          this.cpfTitular = this.values.cpf;
        }

        this.listaTipoDependentes.find((el) => {
          if (el.value === this.values.tipoDependente) {
            this.values.descTipoDependente = el.label;
          }
        });

        this.listaEstadoCivil.find((el) => {
          if (el.value === this.values.estadoCivil) {
            this.values.descEstadoCivil = el.label;
          }
        });

        this.registros[this.registroSel].cadastroFinal = this.values;
        this.registros[this.registroSel].concluido = true;
        this.lista[this.registroSel].concluido = true;
        const parsed = JSON.stringify(this.registros);
        localStorage.setItem("cdlsaude_cadastro", parsed);

        // Valida os dados do form
        this.$formulate.reset("Cadastro");
        this.registroSel = null;
        this.proximaEtapa = true;
      }
      //this.proximoCadastro();
    },
    proximoCadastro() {
      if (this.registroSel < this.lista.length - 1) {
        this.selecionaCadastro(this.registroSel + 1);
      } else {
        this.registros.forEach((v, i) => {
          if (!v.concluido) {
            this.selecionaCadastro(i);
            return true;
          }
        });
        this.selecionaCadastro(0);
      }
    },
    validaLista() {
      this.registros.forEach((v, i) => {
        if (!v.concluido && v.nome) {
          this.$toast.open({
            message: "Você deve preencher os dados de todas as pessoas.",
            type: "error",
          });
          this.selecionaCadastro(i);
          this.proximaEtapa = false;
          return true;
        }
      });
      if (this.proximaEtapa) {
        this.$router.push({ name: "resumo" });
      }
    },
    async salvarApi() {
      for (const [i, registro] of this.registros.entries()) {
        if (!registro.cadastrado && registro.nome) {
          var result = this.prepararDados(registro);

          await this.$http
            .post("/api/CdlBh/IncluirSamPrevidaArta", result)
            .then((response) => {
              if (response.data.sucesso) {
                this.registros[i].cadastrado = true;
              } else if (response.data.erro) {
                this.registros[i].erro = response.data.mensagem;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      this.enviarArquivos();
    },
    prepararDados(campos) {
      var telefone = clearStr(campos.cadastroFinal.telefone);

      let dados = {
        //codsocio: this.$store.state.userDetails.dadosCadastraisAssociado[0].codseqsocio,
        cpF_TITULAR: clearStr(this.cpfTitular),
        cpF_DEPENDENTE:
          campos.tipoCadastro == "dependente"
            ? clearStr(campos.cadastroFinal.cpf)
            : "",
        nome: campos.nome,
        datanascimento: campos.dataNascimento,
        email: campos.cadastroFinal.email,
        ddd: telefone.slice(0, 2),
        telefone: telefone.slice(2, 11),
        titularidade: campos.cadastroFinal.tipoDependente,
        sexo: campos.cadastroFinal.sexo,
        estadoCivil: campos.cadastroFinal.estadoCivil,
        mae: campos.cadastroFinal.nomeMae,
        rua: campos.cadastroFinal.rua,
        numero: parseInt(campos.cadastroFinal.numero),
        bairro: campos.cadastroFinal.bairro,
        cidade: campos.cadastroFinal.cidade,
        uf: campos.cadastroFinal.estado,
        cep: clearStr(campos.cadastroFinal.cep),
        datavigencia: "2021-04-30",
        codplanofx: campos.plano.codPlano,
        listaOpcional: campos.opcionais,
      };
      return dados;
    },
    enviarArquivos() {
      this.registros.forEach((v, i) => {
        if (!v.cadastrado) {
          this.selecionaCadastro(i);
          return true;
        }
      });
      this.$router.push({ name: "arquivos" });
    },
    verificaTipoDependente() {
      if (this.values.tipoDependente === "05") {
        this.values.estadoCivil = "C";
      }
    },
    validarCpf() {
      var cpf = clearStr(this.values.cpf);

      const result = validateCPF(cpf);
      if (!result) {
        this.invalidCpf = true;
        this.$formulate.handle(
          {
            inputErrors: { cpf: "CPF Inválido!" },
            hasErrors: { cpf: true },
          },
          "Cadastro"
        );
      } else {
        this.invalidCpf = false;
        this.$formulate.handle({ inputErrors: { cpf: null } }, "Cadastro");
      }
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.montaDados();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.produto-cdlsaude-cadastrofinal /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
      button {
        // Style button inputs
      }
    }
  }
}
.label {
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 3px;
  text-transform: capitalize;
}
.value {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
